@if (displayMode === "Kanban" || displayMode === "List") {
    <div class="fancy-scrollbar-newUI wk-view__container" id="virtual-scroller-wrapper" cdkScrollable>
        @for (columnData of columns; track columnData.id) {
            <column-component [hidden]="columnData.state !== 'active'" [isHidden]="columnData.state !== 'active'" [columnData]="columnData" />
        }
    </div>
} @else if (displayMode === "details") {
    <app-assignees-view />
}
<router-outlet />
